// plugins/structuredData.js
import { ref, watch } from "vue";

const getRandomInt = (min, max) => {
	min = Math.ceil(min);
	max = Math.floor(max);
	return Math.floor(Math.random() * (max - min + 1)) + min;
};

export default defineNuxtPlugin((nuxtApp) => {
	if (!import.meta.client) {
		return;
	}
	/** Dev 下跳过 JSON-LD 注入，减轻路由/layout HMR 时的插件与 head 相关重算 */
	if (import.meta.dev) {
		return;
	}

	const structuredData = ref({});

	const updateStructuredData = () => {
		const randomInt = getRandomInt(1000, 2000);
		setTimeout(function () {
			const pageDescription =
				document.querySelector('meta[name="description"]')
					?.content || "";
			structuredData.value = {
				"@context": "https://schema.org",
				"@type": "WebApplication",
				name: document.title,
				url: "https://lip-sync.ai",
				operatingSystem:
					"Windows, MacOS, Linux, Chrome OS, iOS, Android",
				applicationCategory: "MultimediaApplication",
				description: pageDescription,

				aggregateRating: {
					"@type": "AggregateRating",
					ratingValue: 4.9,
					reviewCount: randomInt,
					bestRating: 5,
					worstRating: 1,
				},

				offers: {
					"@type": "Offer",
					price: "0",
					priceCurrency: "USD",
					availability: "https://schema.org/InStock",
				},

				author: {
					"@type": "Organization",
					name: "Lip Sync AI  ",
					url: "https://lip-sync.ai",
					logo: "https://lip-sync.ai/logo-64.webp",
				},
			};
			const scriptId = "lip-webapp-jsonld";
			let scriptTag = document.getElementById(scriptId);
			if (!scriptTag) {
				scriptTag = document.createElement("script");
				scriptTag.id = scriptId;
				scriptTag.type = "application/ld+json";
				document.head.appendChild(scriptTag);
			}
			scriptTag.textContent = JSON.stringify(structuredData.value);
		}, 200);
	};

	nuxtApp.hook("app:mounted", () => {
		const router = useRouter();
		if (!router?.currentRoute) {
			return;
		}
		watch(
			() => router.currentRoute.value.fullPath,
			() => {
				updateStructuredData();
			},
			{ immediate: true },
		);
	});
});
